export class BaseFormEntityRequest {
  fullName: string;
  workcenter: string;
  email: string;
  phone: string;
  comment: string;
}
